import { render, staticRenderFns } from "./TwitterCardVerifiedPnL.vue?vue&type=template&id=16e1264f&scoped=true&"
import script from "./TwitterCardVerifiedPnL.vue?vue&type=script&lang=js&"
export * from "./TwitterCardVerifiedPnL.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCardVerifiedPnL.vue?vue&type=style&index=0&id=16e1264f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1264f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
